import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfirmIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 51,
	height: 51,
	viewBox: "0 0 51 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20.871 33.4879L15.206 26.7549C15.0261 26.5704 14.8111 26.4238 14.5737 26.3237C14.3363 26.2236 14.0812 26.172 13.8235 26.172C13.5659 26.172 13.3108 26.2236 13.0734 26.3237C12.8359 26.4238 12.6209 26.5704 12.441 26.7549C12.0711 27.1249 11.8633 27.6267 11.8633 28.1499C11.8633 28.6731 12.0711 29.1749 12.441 29.5449L19.469 37.6519C19.6508 37.8364 19.8675 37.983 20.1065 38.083C20.3455 38.1831 20.602 38.2346 20.861 38.2346C21.1201 38.2346 21.3766 38.1831 21.6156 38.083C21.8545 37.983 22.0712 37.8364 22.253 37.6519L38.458 16.3719C38.828 16.0019 39.0358 15.5001 39.0358 14.9769C39.0358 14.4537 38.828 13.9519 38.458 13.5819C38.2781 13.3974 38.0631 13.2508 37.8257 13.1507C37.5883 13.0506 37.3332 12.999 37.0755 12.999C36.8179 12.999 36.5628 13.0506 36.3254 13.1507C36.0879 13.2508 35.8729 13.3974 35.693 13.5819L20.871 33.4879Z",
		fill: "#1da193"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M25.5 49C38.4787 49 49 38.4787 49 25.5C49 12.5213 38.4787 2 25.5 2C12.5213 2 2 12.5213 2 25.5C2 38.4787 12.5213 49 25.5 49Z",
		stroke: "#1da193",
		strokeWidth: 3
	})]
});
export { SvgConfirmIcon as ReactComponent };
